import { trapFocus } from '@theme/focus';
class CategoryNavigation extends HTMLElement {
  connectedCallback() {
    this.details = this.closest('details');
    this.stack = [];
    this.onClick = (event) => {
      const open = event.target.closest('[data-category-open]');
      const back = event.target.closest('[data-category-back]');
      if (open) {
        this.stack.push(open);
        this.show(open.dataset.categoryOpen, true);
        open.setAttribute('aria-expanded', 'true');
      } else if (back) {
        this.back(back.dataset.categoryBack);
      }
    };
    this.onKey = (event) => {
      if (event.key === 'Escape' && this.stack.length) {
        event.preventDefault();
        event.stopPropagation();
        const trigger = this.stack[this.stack.length - 1];
        this.back(trigger.closest('[data-category-panel]').dataset.categoryPanel);
      }
    };
    this.addEventListener('click', this.onClick);
    this.addEventListener('keyup', this.onKey);
    this.observer = new MutationObserver(() => {
      if (!this.details.open) {
        this.stack = [];
        this.show('root', false);
        this.querySelectorAll('[aria-expanded]').forEach((node) => node.setAttribute('aria-expanded', 'false'));
      }
    });
    this.observer.observe(this.details, { attributes: true, attributeFilter: ['open'] });
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keyup', this.onKey);
    this.observer?.disconnect();
  }
  show(key, focus) {
    const panels = [...this.querySelectorAll('[data-category-panel]')];
    panels.forEach((panel) => { panel.hidden = panel.dataset.categoryPanel !== key; });
    const active = panels.find((panel) => !panel.hidden);
    if (this.details.open) trapFocus(this.details);
    if (focus) active?.querySelector('h2')?.focus({ preventScroll: true });
    this.closest('.menu-drawer')?.scrollTo({ top: 0 });
  }
  back(key) {
    const trigger = this.stack.pop();
    this.show(key, false);
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.focus({ preventScroll: true });
  }
}
if (!customElements.get('at-category-navigation')) customElements.define('at-category-navigation', CategoryNavigation);
